import styled, { createGlobalStyle, css } from 'styled-components'
import { ButtonDiv } from '../../containers/AdminPanel/WinrestForm'
import { ActionLink } from '../../containers/AdminPanel/MenuSettings'

const pageSizes = {
    A4: {
        width: '210mm',
        height: '296mm',
    },
    A5: {
        width: '148mm',
        height: '209mm',
    },
    A3: {
        width: '297mm',
        height: '420mm',
    },
}

export const GlobalStyle = createGlobalStyle`
    zoom: ${props => props.zoom}; /* 1.8 */
    @media print {
        @page {
            ${props =>
                props.orientation &&
                css`
                    size: ${props.orientation};
                `}
            /* size: ${props => props.orientation}; */
            margin: 0;
        }
    }
`

export const Page = styled.div`
    position: relative;
    max-width: ${props =>
        props.orientation === 'landscape'
            ? pageSizes[props.size].height
            : pageSizes[props.size].width};
    height: ${props =>
        props.orientation === 'landscape'
            ? pageSizes[props.size].width
            : pageSizes[props.size].height};
    max-height: ${props =>
        props.orientation === 'landscape'
            ? pageSizes[props.size].width
            : pageSizes[props.size].height};

    ${props =>
        props.centered &&
        css`
            margin: auto;
        `}
    background-color: #fff;

    @media print {
        margin: 0 auto;
    }
`

export const PrintHeader = styled.div`
    height: 3cm;
    background-color: ${_ => _.theme.header_background};
    position: relative;

    h1 {
        font-weight: 400;
        color: ${_ => _.theme.header_font_color};
        margin: 0;
        line-height:  ${props => props.showDate ? '1.3cm': '3cm'};
        letter-spacing: 0;

        font-family: ${_ => _.theme.print_header_font_family || _.theme.header_font_family};
        font-size: ${_ => _.theme.print_header_font_size || _.theme.header_font_size || '1.7em'};
        color: ${props => props.theme.header_font_color || '#eff1f1'};

        ${props => props.showDate && css`
            display: flex;
            flex-direction: column;
            align-items: center;
        `}

        small {
            font-size: .7em;
        }
    }

    img {
        position: absolute;
        bottom: 0;
        left: 6%;
        height: 105px;
        display: ${props => (props.size === 'A5' ? 'none' : 'block')};
    }
`

export const TopMenuBorder = styled.span`
    position: absolute;
    left: 1cm;
    right: 1cm;
    top: 1.5cm;
    height: 2px;
    background-color: ${props => props.theme.print_borders_color || '#f28e1b'};
`

export const BottomMenuBorder = styled.span`
    position: absolute;
    left: 1cm;
    right: 1cm;
    bottom: 1cm;
    border-bottom: 2px solid
        ${props => props.theme.print_borders_color || '#f28e1b'};
`

export const PageBorder = styled.span`
    border-right: 2px solid
        ${props => props.theme.print_borders_color || '#f28e1b'};
    position: absolute;
    top: ${({ fullSize }) => (fullSize ? '1.5cm' : '3cm')};
    height: ${({ fullSize }) =>
        fullSize ? 'calc(100% - 2.5cm)' : 'calc(100% - 4cm)'};
    right: ${({ side }) => (side === 'right' ? '1cm' : 'unset')};
    left: ${({ side }) => (side === 'left' ? '1cm' : 'unset')};
`

export const Grid = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;

    /* height: ${props =>
        props.orientation === 'landscape'
            ? pageSizes[props.size].width
            : pageSizes[props.size].height}; */
    
    height: ${props =>
        props.isMonoKiosk
            ? '100%'
            : props.orientation === 'landscape'
            ? `calc(${pageSizes[props.size].width} - 4cm)`
            : `calc(${pageSizes[props.size].height} - 4cm)`};


    padding: 0 14mm;

    font-family: ${props => props.theme.content_font_family || 'CorporateS'};
    zoom: ${({ zoom }) => zoom};
`

export const ActionButtons = styled(ActionLink)`
    margin: 0;
    position: fixed;
    top: 0;
    right: 0;

    display: flex;
`

export const ActionButton = styled(ButtonDiv)`
    font-size: 1.5em;
    background-color: #f28d1b;
    border-radius: 24px;
`

export const MonoKioskDate = styled.div`
    position: absolute;
    right: 1cm;
    top: 0.5cm;
    z-index: 1000;
` 